import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { RepasseService } from "../../services/RepasseService";
import { ExercicioService } from "../../services/ExercicioService";
import { UnidadeExecutoraService } from "../../services/UnidadeExecutoraService";
import { UnidadeOrcamentariaService } from "../../services/UnidadeOrcamentariaService";
import { ProgramaService } from "../../services/ProgramaService";
import { GrupoService } from "../../services/GrupoService";
import { ElementoService } from "../../services/ElementoService";
import { ElementoItemService } from "../../services/ElementoItemService";
import { FonteService } from "../../services/FonteService";
import moment from "moment";

export default {
    name: "GerenciarRepasses",
    components: {
        Breadcrumb,
        StandardPagination,
        ActionButtons
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Repasses',
                disabled: false
            },
            {
                text: 'Gerenciamento de Repasses Orçamentários',
                disabled: true
            }
        ],
        headers: [
            { text: 'Exercício', align: 'center', value: 'exercicio', width: '100px' },
            { text: 'Código Repasse', align: 'center', value: 'codigo_repasse', width: '120px' },
            { text: 'Unid. Executora Origem', align: 'center', value: 'unidade_executora_origem', width: '150px' },
            { text: 'Unid. Executora Destino', align: 'center', value: 'unidade_executora_destino', width: '150px' },
            { text: 'Programa', align: 'center', value: 'programa', width: '150px' },
            { text: 'Grupo', align: 'center', value: 'grupo', width: '150px' },
            { text: 'Elemento', align: 'center', value: 'elemento', width: '150px' },
            { text: 'Elemento Item', align: 'center', value: 'elemento_item', width: '150px' },     
            { text: 'Fonte', align: 'center', value: 'fonte', width: '150px' },         
            { text: 'Data Repasse', align: 'center', value: 'data_repasse', width: '120px' },
            { text: 'Valor Repasse Líquido', align: 'center', value: 'valor_liquido', width: '140px' },
        ],
        filters: {
            codigoFilter: null,
            exercicioFilter: null,
            unidadeExecutoraDestinoFilter: null,
            unidadeExecutoraOrigemFilter: null,
            acaoFilter: null,
            programaFilter: null,
            grupoFilter: null,
            elementoFilter: null,
            elementoItemFilter: null,
            ipgFilter: null,
            fonteFilter: null,
            descentralizacaoAtivoFilter: false,
            descentralizacaoInativoFilter: false,
            dataInicio: null,
            dataFim: null,
        },
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        acaoOptions: [],
        ipuOptions: [],
        ipgOptions: [],
        grupoOptions: [],
        programaOptions: [],
        elementoOptions: [],
        elementoItemOptions: [],
        fonteOptions: [],
        unidadeExecutoraOrigemOptions: [],
        unidadeExecutoraDestinoOptions: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 20, 50],
        showFilters: true
    }),
    computed: {
        computedHeaders() {
            return this.headers;
        },
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
    },
    created() {
        this.listarRepassesPaginado();
        this.listarExerciciosSelect();
        this.listarGruposSelect();
        this.listarProgramasSelect();
        this.listarElementosItensSelect();
        this.listarElementosSelect();
        this.listarFontesSelect();
        this.listarUnidadeExecutoraSelect();
        this.listarUnidadeOrcamentariaSelect()
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarRepassesPaginado();
        },
        'filters.codigoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.unidadeExecutoraOrigemFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.unidadeExecutoraDestinoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.unidadeOrcamentariaFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.programaFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.grupoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.elementoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.elementoItemFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.fonteFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.dataInicio': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        },
        'filters.dataFim': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarRepassesPaginado();
            }
        }
    },
    methods: {
        async listarRepassesPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await RepasseService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.grupoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.grupoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarProgramasSelect() {
            try {
                const response = await ProgramaService.select();
                if (response) {
                    this.programaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_programa} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.programaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarUnidadeExecutoraSelect() {
            try {
                const response = await UnidadeExecutoraService.select();
                if (response) {
                    this.unidadeExecutoraOrigemOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeExecutoraOrigemOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                    this.unidadeExecutoraDestinoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeExecutoraDestinoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarUnidadeOrcamentariaSelect() {
            try {
                const response = await UnidadeOrcamentariaService.select();
                if (response) {
                    this.unidadeOrcamentariaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeOrcamentariaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementoItemOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoItemOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarElementosSelect() {
            try {
                const response = await ElementoService.select();
                if (response) {
                    this.elementoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async listarFontesSelect() {
            try {
                const response = await FonteService.select();
                if (response) {
                    this.fonteOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_fonte} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.fonteOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os repasses.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os repasses:', error);
            }
        },
        async destroyRepasses() {
            try {
                const ids = this.itemSelected.map(repasse => repasse.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("repasses[]", id);
                });

                const response = await RepasseService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os repasses.');
                }

                this.listarRepassesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os repasses:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("items_per_page", this.itemsPerPage);

            this.filters.exercicioFilter
            ? filter.append(
                "exercicio",
                this.filters.exercicioFilter
            )
            : null;

            this.filters.codigoFilter
            ? filter.append(
                "codigo_descentralizacao",
                this.filters.codigoFilter
            )
            : null;

            this.filters.unidadeExecutoraOrigemFilter
            ? filter.append(
                "unidade_executora_origem_id",
                this.filters.unidadeExecutoraOrigemFilter
            )
            : null;

            this.filters.unidadeExecutoraDestinoFilter
                ? filter.append(
                    "unidade_executora_destino_id",
                    this.filters.unidadeExecutoraDestinoFilter
                )
                : null;

            this.filters.programaFilter
                ? filter.append(
                    "programa_id",
                    this.filters.programaFilter
                )
                : null;    

            this.filters.acaoFilter
                ? filter.append(
                    "acao_id",
                    this.filters.acaoFilter
                )
                : null;        

            this.filters.grupoFilter
                ? filter.append(
                    "grupo_id",
                    this.filters.grupoFilter
                )
                : null;  

            this.filters.elementoFilter
                ? filter.append(
                    "elemento_id",
                    this.filters.elementoFilter
                )
                : null;      

            this.filters.elementoItemFilter
                ? filter.append(
                    "elemento_item_id",
                    this.filters.elementoItemFilter
                )
                : null;     
                
            this.filters.fonteFilter
                ? filter.append(
                    "fonte_id",
                    this.filters.fonteFilter
                )
                : null;    

            this.filters.dataInicio
                ? filter.append(
                    "data_ini",
                    moment(this.filters.dataInicio).format("YYYY-MM-DD")
                  )
                : null;
            this.filters.dataFim
                ? filter.append(
                    "data_fim",
                    moment(this.filters.dataFim).format("YYYY-MM-DD")
                  )
                : null;

            return filter;
        },
        clearFilters() {
            Object.keys(this.filters).forEach(key => {
                this.filters[key] = null;
            });
            this.page = 1;
            this.listarRepassesPaginado();
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        getRowClass() {
            return 'table-row';
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + '...';
        },
        formatCurrency(value) {
            if (value == null || value === undefined) return 'R$ 0,00';
            const numValue = typeof value === 'string' ? parseFloat(value) : value;
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numValue);
        },
        formatDate(date) {
            if (!date) return '-';
            return moment(date).format('DD/MM/YYYY');
        },
        handlePageChange(newPage) {
            this.page = newPage;
            this.listarRepassesPaginado();
        },
        handleItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarRepassesPaginado();
        },
        exportarRepasses() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        handleVisualizarRepasse() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/repasses/visualizar/${this.itemSelected[0].id}`);
            }
        },
        handleImportar() {
            this.$router.push('/importar-repasses-orcamentarios');
        },
        formatCodigo(codigo1, codigo2) {
            if (codigo1 == 0 && codigo2 == 0) {
              return '0';
            } else if (codigo1 == 0) {
              return `${codigo2}`;
            } else if (codigo2 == 0) {
              return `${codigo1}`;
            } else if (codigo1 < 10 && codigo2 >= 10) {
              return `${codigo2}${codigo1}`;
            } else if (codigo1 >= 10 && codigo2 < 10) {
                return `${codigo1}0${codigo2}`;
            } else {
              return `${codigo1}${codigo2}`;
            }
        },
        formatDescricao(descricao1, descricao2) {
            if (!descricao1 && !descricao2) return '-';
            if (descricao1 == descricao2) {
                return descricao1;
            } else if (!descricao1) {
                return descricao2;
            } else if (!descricao2) {
                return descricao1;
            } else {
                return `${descricao1} - ${descricao2}`;
            }
        }
        
    }
};
